(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artificial-tree-frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeComplementaryProducts = () => {
      document.querySelectorAll('[data-artificial-tree-complementary]').forEach((section) => {
        if (section.dataset.complementaryInitialized === 'true') return;
        if (section.querySelector('[data-product-row]')) return;

        section.dataset.complementaryInitialized = 'true';

        const loadRecommendations = () => {
          fetch(section.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('[data-artificial-tree-complementary]');

              if (recommendations && recommendations.innerHTML.trim().length) {
                section.innerHTML = recommendations.innerHTML;
              }
            })
            .catch(() => {});
        };

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            loadRecommendations();
          }, { rootMargin: '0px 0px 300px 0px' });

          observer.observe(section);
        } else {
          loadRecommendations();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeComplementaryProducts);
    } else {
      initializeComplementaryProducts();
    }

    document.addEventListener('shopify:section:load', initializeComplementaryProducts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-christmas-showroom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('newlands-showroom')) {
  customElements.define('newlands-showroom', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.querySelectorAll('[data-nlx-open]').forEach(button => button.addEventListener('click', () => {
        this.opener = button;
        this.savedScroll = window.scrollY;
        this.dialog.showModal();
        window.scrollTo({top:this.savedScroll,behavior:"instant"});
        this.dialog.querySelector('video')?.play().catch(() => {});
      }, options));
      this.querySelector('[data-nlx-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.dialog.querySelector('video')?.pause();
        this.opener?.focus({preventScroll:true});
        window.scrollTo({top:this.savedScroll,behavior:"instant"});
      }, options);
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-contact"]) return;
  try {
    
function focusContactStatus() {
  const status = document.querySelector('.nc-page #nc-sent, .nc-page #nc-errors');
  if (status) { status.scrollIntoView({ block: 'center' }); status.focus({ preventScroll: true }); }
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', focusContactStatus, { once: true }); } else { focusContactStatus(); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-opening-night"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('newlands-opening-countdown')) {
  customElements.define('newlands-opening-countdown', class extends HTMLElement {
    connectedCallback() {
      this.deadline = Date.parse(this.dataset.deadline);
      this.nodes = ['days','hours','minutes','seconds'].map(unit => this.querySelector('[data-nl-' + unit + ']'));
      if (!Number.isFinite(this.deadline)) { this.hidden = true; return; }
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(),1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const remaining = Math.max(0,Math.floor((this.deadline-Date.now())/1000));
      const values = [Math.floor(remaining/86400),Math.floor(remaining/3600)%24,Math.floor(remaining/60)%60,remaining%60];
      this.nodes.forEach((node,index) => { if (node) node.textContent = String(values[index]).padStart(2,'0'); });
      if (remaining === 0) {
        clearInterval(this.interval);
        this.querySelector('.nl-opening__clock').hidden = true;
        this.querySelector('.nl-opening__countdown-label').hidden = true;
        this.querySelector('.nl-opening__complete').hidden = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-plant-collection-draft"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.npl .npd-rose-ranges').forEach(function(range,index){var grid=range.querySelector('.npd-rose-links');var button=range.querySelector('.npl-show-all');if(!grid)return;if(!button){button=document.createElement('button');button.type='button';button.className='npl-show-all';button.textContent='Show all collections';button.setAttribute('aria-expanded','false');range.appendChild(button);}if(button.dataset.bound)return;if(grid.children.length<=6){button.hidden=true;return;}grid.id='npl-range-'+index;grid.dataset.collapsible='true';button.setAttribute('aria-controls',grid.id);button.dataset.bound='true';button.addEventListener('click',function(){var expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));grid.dataset.expanded=String(expanded);button.textContent=expanded?'Show fewer collections':'Show all collections';});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-plant-confidence"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ng-related-row').forEach(row=>{if(window.Shopify&&window.Shopify.designMode)return;const cards=Array.from(row.querySelectorAll('.ng-companion'));for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.appendChild(card));row.appendChild(fragment);});

document.addEventListener('click',event=>{const button=event.target.closest('[data-related-step]');if(!button)return;const row=button.closest('.ng-related').querySelector('.ng-related-row');const card=row.querySelector('.ng-companion');if(card)row.scrollBy({left:Number(button.dataset.relatedStep)*(matchMedia('(max-width: 700px)').matches?1:4)*(card.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
document.querySelectorAll('.ng-related').forEach(section=>{const row=section.querySelector('.ng-related-row'),nav=section.querySelector('.ng-related-nav');if(!row||!nav)return;const update=()=>{section.style.setProperty('--ng-related-top',(row.offsetTop+row.clientHeight/2-24)+'px');nav.querySelector('[data-related-step="-1"]').disabled=row.scrollLeft<2;nav.querySelector('[data-related-step="1"]').disabled=row.scrollLeft>=row.scrollWidth-row.clientWidth-2;};row.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(row);update();});

function newlandsRoseFulfilment(){
document.querySelectorAll('[data-rose-fulfilment]').forEach(box=>{
if(box.dataset.bound)return;box.dataset.bound='true';
const root=box.closest('[data-section-id]')||box.closest('.shopify-section');
const form=root.querySelector('[data-product-form]');
const notice=box.querySelector('.nr-preorder-note');
const special=box.querySelector('.nr-special-delivery');
const data=JSON.parse(box.querySelector('[data-rose-variant-rules]').textContent);
const action=form&&form.querySelector('.product-form__action-wrapper');
if(action)action.appendChild(notice);
function update(){
const input=form&&form.querySelector('[name="id"]');
const v=data.find(x=>String(x.id)===String(input&&input.value))||data[0];
if(!v)return;
const pre=box.dataset.roseSeason==='true'&&v.tracked&&v.stock<=0;
notice.hidden=!pre;special.hidden=v.weight<30000;
root.querySelectorAll('.visual_timer_wrapper1,.delivery_timer_wrapper1,.ng-delivery-heading').forEach(e=>{e.style.setProperty('display',pre||v.weight>=30000?'none':'',pre||v.weight>=30000?'important':'');});
}
update();if(form)form.addEventListener('change',()=>setTimeout(update,100));
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',newlandsRoseFulfilment);else newlandsRoseFulfilment();
document.addEventListener('shopify:section:load',newlandsRoseFulfilment);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-plant-displays"] && !Shopify.designMode) return;
  try {
    
function initialiseAquascapeGalleries() {
  document.querySelectorAll('.np-gallery').forEach(gallery => {
    const controls = gallery.querySelector('[data-gallery-controls]');
    if (!controls || controls.dataset.ready) return;
    controls.dataset.ready = 'true';
    controls.hidden = false;
    controls.addEventListener('click', event => {
      const button = event.target.closest('[data-gallery-size]');
      if (!button) return;
      const size = button.dataset.gallerySize;
      controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      gallery.querySelectorAll('[data-tank-size]').forEach(card => { card.hidden = size !== 'all' && card.dataset.tankSize !== size; });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAquascapeGalleries);
else initialiseAquascapeGalleries();
document.addEventListener('shopify:section:load', initialiseAquascapeGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-plant-expert-picks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',async event=>{const form=event.target.closest('.ng-expert-form');if(!form)return;event.preventDefault();const button=form.querySelector('button');const status=form.querySelector('[role="status"]');button.disabled=true;status.textContent='Adding…';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description||'Unable to add this item.');status.textContent='Added to your basket.';const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());document.querySelectorAll('[data-header-cart-count],.site-header-cart--count').forEach(el=>{el.textContent=cart.item_count;el.classList.toggle('visible',cart.item_count>0);});}catch(error){status.textContent=error.message||'Please try again.';}finally{button.disabled=false;}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-rose-confidence"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ng-related-row').forEach(row=>{if(window.Shopify&&window.Shopify.designMode)return;const cards=Array.from(row.querySelectorAll('.ng-companion'));for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.appendChild(card));row.appendChild(fragment);});

document.addEventListener('click',event=>{const button=event.target.closest('[data-related-step]');if(!button)return;const row=button.closest('.ng-related').querySelector('.ng-related-row');const card=row.querySelector('.ng-companion');if(card)row.scrollBy({left:Number(button.dataset.relatedStep)*(matchMedia('(max-width: 700px)').matches?1:4)*(card.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
document.querySelectorAll('.ng-related').forEach(section=>{const row=section.querySelector('.ng-related-row'),nav=section.querySelector('.ng-related-nav');if(!row||!nav)return;const update=()=>{section.style.setProperty('--ng-related-top',(row.offsetTop+row.clientHeight/2-24)+'px');nav.querySelector('[data-related-step="-1"]').disabled=row.scrollLeft<2;nav.querySelector('[data-related-step="1"]').disabled=row.scrollLeft>=row.scrollWidth-row.clientWidth-2;};row.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(row);update();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-rose-expert-picks"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ng-expert-row').forEach(row=>{if(window.Shopify&&window.Shopify.designMode)return;const cards=Array.from(row.querySelectorAll('.ng-expert-card'));for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}const fragment=document.createDocumentFragment();cards.forEach(card=>fragment.appendChild(card));row.appendChild(fragment);});

document.addEventListener('click',event=>{const button=event.target.closest('[data-expert-step]');if(!button)return;const row=button.closest('.ng-expert').querySelector('.ng-expert-row');const card=row.querySelector('.ng-expert-card');if(card)row.scrollBy({left:Number(button.dataset.expertStep)*(matchMedia('(max-width: 700px)').matches?1:4)*(card.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});
document.addEventListener('submit',async event=>{const form=event.target.closest('.ng-expert-form');if(!form)return;event.preventDefault();const button=form.querySelector('button');const status=form.querySelector('[role="status"]');button.disabled=true;status.textContent='Adding…';try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});const data=await response.json();if(!response.ok)throw new Error(data.description||'Unable to add this item.');status.textContent='Added to your basket.';const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());document.querySelectorAll('[data-header-cart-count],.site-header-cart--count').forEach(el=>{el.textContent=cart.item_count;el.classList.toggle('visible',cart.item_count>0);});}catch(error){status.textContent=error.message||'Please try again.';}finally{button.disabled=false;}});
document.querySelectorAll('.ng-expert').forEach(section=>{const row=section.querySelector('.ng-expert-row');const nav=section.querySelector('.ng-expert-nav');if(!row||!nav)return;const update=()=>{section.style.setProperty('--ng-nav-top',(row.offsetTop+row.clientHeight/2-24)+'px');nav.querySelector('[data-expert-step="-1"]').disabled=row.scrollLeft<2;nav.querySelector('[data-expert-step="1"]').disabled=row.scrollLeft>=row.scrollWidth-row.clientWidth-2;};row.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(row);update();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newlands-rose-guide"] && !Shopify.designMode) return;
  try {
    
function newlandsRoseFulfilment(){
document.querySelectorAll('[data-rose-fulfilment]').forEach(box=>{
if(box.dataset.bound)return;box.dataset.bound='true';
const root=box.closest('[data-section-id]')||box.closest('.shopify-section');
const form=root.querySelector('[data-product-form]');
const notice=box.querySelector('.nr-preorder-note');
const special=box.querySelector('.nr-special-delivery');
const data=JSON.parse(box.querySelector('[data-rose-variant-rules]').textContent);
const action=form&&form.querySelector('.product-form__action-wrapper');
if(action)action.insertBefore(notice,action.firstChild);
function update(){
const input=form&&form.querySelector('[name="id"]');
const v=data.find(x=>String(x.id)===String(input&&input.value))||data[0];
if(!v)return;
const pre=box.dataset.roseSeason==='true'&&v.tracked&&v.stock<=0;
notice.hidden=!pre;special.hidden=v.weight<30000;
const button=form&&form.querySelector('[data-product-atc]');
if(button&&!button.disabled){
const label=button.querySelector('.atc-button--text');
if(label){if(!button.dataset.regularLabel)button.dataset.regularLabel=pre?'Add to basket':label.textContent.trim();label.textContent=pre?'Pre-order':button.dataset.regularLabel;}
button.toggleAttribute('data-product-atc-preorder',pre);
}
root.querySelectorAll('.visual_timer_wrapper1,.delivery_timer_wrapper1,.ng-delivery-heading').forEach(e=>{e.style.setProperty('display',pre||v.weight>=30000?'none':'',pre||v.weight>=30000?'important':'');});
}
update();if(form)form.addEventListener('change',()=>setTimeout(update,100));
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',newlandsRoseFulfilment);else newlandsRoseFulfilment();
document.addEventListener('shopify:section:load',newlandsRoseFulfilment);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-cart"]) return;
  try {
    
(() => {
 const root=document.querySelector('.nl-basket-shipping');
 if(!root)return;
 const country=root.querySelector('#nl-shipping-country'),province=root.querySelector('#nl-shipping-province'),wrap=root.querySelector('#nl-shipping-province-wrap'),zip=root.querySelector('#nl-shipping-zip'),button=root.querySelector('.nl-shipping-calculate'),result=root.querySelector('.nl-shipping-results');
 if([...country.options].some(o=>o.value==='Ireland'))country.value='Ireland';
 const populate=()=>{let values=[];try{values=JSON.parse(country.selectedOptions[0].dataset.provinces||'[]');}catch{}province.replaceChildren();for(const [value,label] of values)province.add(new Option(label,value));wrap.hidden=values.length===0;};
 country.addEventListener('change',populate);populate();
 button.addEventListener('click',async()=>{button.disabled=true;result.textContent=result.dataset.loading;try{const query=new URLSearchParams({'shipping_address[country]':country.value,'shipping_address[province]':province.value,'shipping_address[zip]':zip.value});const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/shipping_rates.json?'+query.toString());const data=await response.json();if(!response.ok)throw new Error();result.replaceChildren();if(!data.shipping_rates?.length){result.textContent=result.dataset.empty;}else{const list=document.createElement('ul');const formatter=new Intl.NumberFormat(document.documentElement.lang||'en-IE',{style:'currency',currency:result.dataset.currency||'EUR'});for(const rate of data.shipping_rates){const li=document.createElement('li');li.textContent=rate.name+' — '+formatter.format(Number(rate.price));list.append(li);}result.append(list);}}catch{result.textContent=result.dataset.error;}finally{button.disabled=false;}});
})();

  } catch(e) { console.error(e); }
})();
})();
